import { WAIT_FOR_ACTION, ERROR_ACTION } from "redux-wait-for-action";
import { appendGaEventToAction } from "./googleAnalytics";

export const RECEIVE_APPCONFIG = "RECEIVE_APPCONFIG";
export const RECEIVE_APPCONFIG_SUCCESS = "RECEIVE_APPCONFIG_SUCCESS";
export const RECEIVE_APPCONFIG_FAIL = "RECEIVE_APPCONFIG_FAIL";
export const UPDATE_PROSPECT = "UPDATE_PROSPECT";
export const UPDATE_ROPROSPECT = "UPDATE_ROPROSPECT";
export const RESET_PROSPECT = "RESET_PROSPECT";
export const RESET_RO_PROSPECT = "RESET_RO_PROSPECT";
export const SET_CONFIG = "SET_CONFIG";
export const SET_PROSPECT = "SET_PROSPECT";
export const UPDATE_PROSPECT_ID = "UPDATE_PROSPECT_ID";
export const UPDATE_VIEW_ID = "UPDATE_VIEW_ID";
export const REMOVE_PROSPECT_ID = "REMOVE_PROSPECT_ID";
export const SAVE_SIGNATORY_MODEL = "SAVE_SIGNATORY_MODEL";
export const SAVE_RO_SIGNATORY_MODEL = "SAVE_RO_SIGNATORY_MODEL";
export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
export const RESET_APPLICANT_INFO = "RESET_APPLICANT_INFO";
export const LOAD_META_DATA = "LOAD_META_DATA";
export const SET_PROSPECT_LEAD = "SET_PROSPECT_LEAD";
export const SET_EXPIRED = "SET_EXPIRED";
export const UPDATE_CONSENT_EMAIL_TRIGGER_TIME = "UPDATE_CONSENT_EMAIL_TRIGGER_TIME";
export const SET_RO_CODE = "SET_RO_CODE";
export const UPDATE_APPLICATION_STATUS = "UPDATE_APPLICATION_STATUS";
export const RESET_REJECT_REASON = "RESET_REJECT_REASON";
export const UPDATE_EXISTING_CUSTOMER = "UPDATE_EXISTING_CUSTOMER";
export const UPDATE_SUB_SOURCE = "UPDATE_SUB_SOURCE";
export const SET_SCREENING_RESULTS = "SET_SCREENING_RESULTS";
export const RECEIVE_DATALIST_SEARCH = "RECEIVE_DATALIST_SEARCH";
export const RECEIVE_DATALIST_SEARCH_SUCCESS = "RECEIVE_DATALIST_SEARCH_SUCCESS";
export const RECEIVE_DATALIST_SEARCH_FAIL = "RECEIVE_DATALIST_SEARCH_FAIL";

export const loadMetaData = (meta = {}) => ({
  type: LOAD_META_DATA,
  payload: meta.freeField5 || ""
});

export const receiveAppConfig = () => ({
  type: RECEIVE_APPCONFIG
});

export const receiveAppConfigSuccess = payload => {
  payload.roProspectModel = payload.roProspect;
  return { type: RECEIVE_APPCONFIG_SUCCESS, payload };
};

export const receiveAppConfigFail = payload => {
  return { type: RECEIVE_APPCONFIG_FAIL, payload };
};

export const updateProspect = (payload, gaEvent = null) => {
  const action = { type: UPDATE_PROSPECT, payload };

  return appendGaEventToAction(action, gaEvent);
};

export const updateRoProspect = (payload, gaEvent = null) => {
  const action = { type: UPDATE_ROPROSPECT, payload };

  return appendGaEventToAction(action, gaEvent);
};

export const setConfig = payload => {
  return { type: SET_CONFIG, payload };
};

export const setProspect = payload => {
  return { type: SET_PROSPECT, payload };
};

export const resetProspect = () => {
  return { type: RESET_PROSPECT };
};

export const resetRoProspect = payload => {
  return { type: RESET_RO_PROSPECT, payload };
};

export const updateProspectId = payload => {
  return { type: UPDATE_PROSPECT_ID, payload };
};

export const removeProspectId = () => {
  return { type: REMOVE_PROSPECT_ID };
};

export const updateViewId = (viewId, isSendToApi, isRoFlow = false) => {
  return { type: UPDATE_VIEW_ID, payload: { viewId, isSendToApi, isRoFlow } };
};

export const saveSignatoryModel = payload => {
  return { type: SAVE_SIGNATORY_MODEL, payload };
};

export const saveRoSignatoryModel = payload => {
  return { type: SAVE_RO_SIGNATORY_MODEL, payload };
};

export const setAccessToken = (accessToken, refreshToken = "") => ({
  type: SET_ACCESS_TOKEN,
  payload: { accessToken, refreshToken }
});

export const resetApplicantInfo = () => ({ type: RESET_APPLICANT_INFO });

export const setProspectLead = payload => {
  return { type: SET_PROSPECT_LEAD, payload };
};

export const setExpired = expired => ({ type: SET_EXPIRED, payload: expired });

export const updateConsentEmailTime = (consentEmailTriggerTime, isSendToApi) => {
  return {
    type: UPDATE_CONSENT_EMAIL_TRIGGER_TIME,
    payload: { consentEmailTriggerTime, isSendToApi }
  };
};

export const updateApplicationStatus = payload => ({
  type: UPDATE_APPLICATION_STATUS,
  payload
});

export const setRoCode = payload => {
  return { type: SET_RO_CODE, payload };
};

export const resetRejectReason = payload => {
  return { type: RESET_REJECT_REASON, payload };
};

export const updateExistingCustomer = payload => {
  return { type: UPDATE_EXISTING_CUSTOMER, payload };
};

export const updateSubSource = payload => {
  return { type: UPDATE_SUB_SOURCE, payload };
};

export const updateScreeningResults = payload => {
  return { type: SET_SCREENING_RESULTS, payload };
};

export const receiveDatalistSearchPromisify = data => ({
  type: RECEIVE_DATALIST_SEARCH,
  [WAIT_FOR_ACTION]: RECEIVE_DATALIST_SEARCH_SUCCESS,
  [ERROR_ACTION]: RECEIVE_DATALIST_SEARCH_FAIL,
  payload: {
    codeType: data.codeType,
    searchPattern: data.searchPattern
  }
});

export const receiveDatalistSearchSuccess = payload => {
  return { type: RECEIVE_DATALIST_SEARCH_SUCCESS, payload };
};

export const receiveDatalistSearchFail = payload => {
  return { type: RECEIVE_DATALIST_SEARCH_FAIL, payload };
};
